export default "__VITE_ASSET__UI2EBlTZ__"